export default {"src":"/_next/static/media/Grape.66b8ad8d.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};